module.exports = __webpack_public_path__ + "img/bahan.53d273e7.jpg";